import React,{ useState } from 'react'
import SideBar from '../components/admin/SideBar'
import logo from '../logo-short.png';
import { signOut } from '../adapters/authentication';
import useAuthStore from '../store/auth';
import { Outlet, useNavigate } from 'react-router-dom';
import Cookies from 'js-cookie'

export default function AdminLayout() {
  const [openMobileMenu, setOpenMobileMenu] = useState(false);
  const clearAuth = useAuthStore((state) => state.clearAuth);
  const [showProfile, setShowProfile] = useState(null);
  const user = useAuthStore((state) => state.user);
  const navigate = useNavigate();
  const logout = () => {
    clearAuth();
    signOut();
    Cookies.remove('auth:token')
    navigate("/auth/sign-in", { replace: true });
  }

  
  return (
      <div className="h-screen relative overflow-hidden flex justify-between items-center bg-gray-200 w-screen ">
        <SideBar mobileMenu={openMobileMenu} />
        <section className='w-full h-full'>
          {/* Top Nav */}
          <header className='sticky top-0 z-10 flex md:justify-end justify-between overflow-hidden items-center bg-white md:px-8 px-4 py-0 h-16 w-full'>
            <div className="flex justify-start md:hidden items-center gap-2">
              <img className="h-8 w-8" src={logo} alt="logo" />
              <button className="text-gray-800 hover:text-blue-900 transition ease-in-out duration-100 delay-150" onClick={() => {
                setOpenMobileMenu(!openMobileMenu);
              }}>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-6 h-6">
                  <path fillRule="evenodd" d="M3 6.75A.75.75 0 013.75 6h16.5a.75.75 0 010 1.5H3.75A.75.75 0 013 6.75zM3 12a.75.75 0 01.75-.75H12a.75.75 0 010 1.5H3.75A.75.75 0 013 12zm0 5.25a.75.75 0 01.75-.75h16.5a.75.75 0 010 1.5H3.75a.75.75 0 01-.75-.75z" clipRule="evenodd" />
                </svg>
              </button>
            </div>
            <div>
              <button className="text-gray-800 flex gap-1 items-center hover:text-blue-900 transition ease-in-out duration-100 delay-150" onClick={logout}>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-6 h-6">
                  <path fillRule="evenodd" d="M7.5 3.75A1.5 1.5 0 006 5.25v13.5a1.5 1.5 0 001.5 1.5h6a1.5 1.5 0 001.5-1.5V15a.75.75 0 011.5 0v3.75a3 3 0 01-3 3h-6a3 3 0 01-3-3V5.25a3 3 0 013-3h6a3 3 0 013 3V9A.75.75 0 0115 9V5.25a1.5 1.5 0 00-1.5-1.5h-6zm10.72 4.72a.75.75 0 011.06 0l3 3a.75.75 0 010 1.06l-3 3a.75.75 0 11-1.06-1.06l1.72-1.72H9a.75.75 0 010-1.5h10.94l-1.72-1.72a.75.75 0 010-1.06z" clipRule="evenodd" />
                </svg>
                <span className="text-xs font-semibold">
                  Logout
                </span>
              </button>
            </div>
          </header>
          <div className="py-6 lg:px-6 px-4">
            <Outlet context={{ user }} />
          </div>
        </section>
      </div>
  )
}
